module.exports = __webpack_public_path__ + "img/edit.91ad810b.svg";